import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _defineMessages;
import { defineMessages } from 'react-intl-next';
//
// ─── INTERFACES ─────────────────────────────────────────────────────────────────
//
export var ApiErrorMessage = /*#__PURE__*/function (ApiErrorMessage) {
  ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
  ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
  ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
  ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
  ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
  ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
  ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
  ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
  ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
  ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
  ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
  ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
  ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
  ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
  ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
  ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
  ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
  ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
  ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
  ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
  ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
  ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
  ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
  ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
  return ApiErrorMessage;
}({});
export var IntlApiErrorMessages = defineMessages((_defineMessages = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, ApiErrorMessage.UnauthorisedTitle, {
  id: 'ui-notices.apiError.title.UnauthorisedTitle',
  defaultMessage: 'Error: User Unauthorised'
}), ApiErrorMessage.UnauthorisedMsg, {
  id: 'ui-notices.apiError.msg.UnauthorisedMsg',
  defaultMessage: 'Try refreshing your page or logging into Jira again.'
}), ApiErrorMessage.MissingPermissionsTitle, {
  id: 'ui-notices.apiError.title.MissingPermissionsTitle',
  defaultMessage: 'Error: User is not allowed this action'
}), ApiErrorMessage.MissingPermissionsMsg, {
  id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
  defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
}), ApiErrorMessage.AddConnectionFailedTitle, {
  id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
  defaultMessage: 'Error: Adding data connection failed'
}), ApiErrorMessage.AddConnectionFailedMsg, {
  id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
  defaultMessage: 'A server error occurred while trying to add the data connection.'
}), ApiErrorMessage.UpdateConnectionFailedTitle, {
  id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
  defaultMessage: 'Error: Updating data connection failed'
}), ApiErrorMessage.UpdateConnectionFailedMsg, {
  id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
  defaultMessage: 'A server error occurred while trying to update the data connection.'
}), ApiErrorMessage.SubmitFormFailedTitle, {
  id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
  defaultMessage: 'Error: Submitting form failed'
}), ApiErrorMessage.SubmitFormFailedMsg, {
  id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
  defaultMessage: 'A server error occurred while trying to submit the form.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, ApiErrorMessage.SaveFormFailedTitle, {
  id: 'ui-notices.apiError.title.SaveFormFailedTitle',
  defaultMessage: 'We couldn’t save your changes',
  description: 'The title on the error flag informing customers that their form failed to save.'
}), ApiErrorMessage.SaveFormFailedMsg, {
  id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
  defaultMessage: 'A server error occurred while trying to save the form.'
}), ApiErrorMessage.SaveFormInvalidAnswersMsg, {
  id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
  defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
  description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
}), ApiErrorMessage.SaveFormFailedOnConflictMsg, {
  id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
  defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
  description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
}), ApiErrorMessage.SaveTemplateFormFailedTitle, {
  id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
  defaultMessage: 'Error: Saving template form failed'
}), ApiErrorMessage.SaveTemplateFormFailedMsg, {
  id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
  defaultMessage: 'A server error occurred while trying to save the template form.'
}), ApiErrorMessage.LoadTemplateFormFailedTitle, {
  id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
  defaultMessage: 'We couldn’t load your form'
}), ApiErrorMessage.LoadTemplateFormFailedMsg, {
  id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
  defaultMessage: 'Refresh the page to try again'
}), ApiErrorMessage.LoadJiraFieldsFailedTitle, {
  id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
  defaultMessage: 'Error: Loading Jira fields failed'
}), ApiErrorMessage.LoadJiraFieldsFailedMsg, {
  id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
  defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, ApiErrorMessage.LoadDataConnectionsFailedTitle, {
  id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
  defaultMessage: 'Error: Loading data connections failed.'
}), ApiErrorMessage.LoadDataConnectionsFailedMsg, {
  id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
  defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
}), ApiErrorMessage.LoadSettingsRefDataFailedTitle, {
  id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
  defaultMessage: 'Error: Loading form settings reference data failed.'
}), ApiErrorMessage.LoadSettingsRefDataFailedMsg, {
  id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
  defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
})));